import { createStore } from 'vuex'

export default createStore({
  state: {
    a:7987
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
